<section class="hero-area bg-1 text-center overly" style="padding: 0px 0 0;">
    <div class="container container-xs">
        <div class="row">
            <div class="col-md-12">
                <div class="content-block" style="padding-bottom:5px;">
                    <h1></h1>
                </div>
                <div class="advance-search">
                    <div class="row">
                        <div class="col-12 p-0 text-center">
                            <div id="custom-search-input">
                                <div class="row">
                                    <div class="col">
                                        <h5 class="teayudo">¡Hola! ¿En qué podemos ayudarte? </h5>
                                        <input class="search-query form-control input-src" placeholder="Buscar" type="search" [ngClass]="{'loading':isLoading}" [spellcheck]="false" (ngModelChange)="search($event)" [(ngModel)]="src" (focus)="onLocationFocus()" (blur)="onLocationBlur()" (keydown.ArrowUp)="onArrowUp()"
                                            (keydown.ArrowDown)="onArrowDown()" (keydown.enter)="onEnter(0)" (keydown.esc)="onEsc()">
                                        <span class="input-group-btn">
                                            <button class="btn btn-success" type="button" (click)="onEnter(0)"> <i class="fas fa-search"></i> </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="results col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12 " *ngIf="!!src && show">
                                <ul style="height: 500px;overflow-y: scroll;">
                                    <li *ngIf="data.length==0 && !errorBusqueda">No se han encontrado resultados.</li>
                                    <li *ngIf="errorBusqueda" class="warning">No se han encontrado resultados.</li>
                                    <li #itemli [ngClass]="{'focus-background': focusElement == itemli.tabIndex}" *ngFor="let item of data; let i = index" tabIndex="{{i}}" (click)="onEnter(item.preguntaId)">
                                        <h4 class="tit_respuesta">
                                            <ngx-highlight-words [textToHighlight]="item.desPregunta" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="onEnter(item.preguntaId)">
                                            </ngx-highlight-words>
                                        </h4>
                                        <span class="ruta">
                                            <ngx-highlight-words [textToHighlight]="item.desBurbuja" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="onEnter(item.preguntaId)">
                                            </ngx-highlight-words> >
                                            <ngx-highlight-words [textToHighlight]="item.desTema" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="onEnter(item.preguntaId)">
                                            </ngx-highlight-words>
                                        </span>

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>